import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_END_POINT } from '@app/core/constants/app-constant';
import { ApiResponse } from '@app/shared/models/ApiResponse';
import { environment } from '@env';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ApiDomainService {
  // private endpoint = environment.endpoint.api_domain;
  apiKey = environment.apiKey;
  header: HttpHeaders;
  constructor(private apiSvc: ApiService) {
    this.header = new HttpHeaders({
      apiKey: this.apiKey,
    });
  }

  getDomainDetails(domain_name): Promise<ApiResponse> {
    // `${this.endpoint}?domain=${domain_name}`
    return this.apiSvc.get(API_END_POINT.getDomainDetails(domain_name), this.header);
  }

  getDomianInfo(customerId): Promise<ApiResponse> {
    // return this.apiSvc.get(`${this.endpoint}?id=${customerId}`, this.header);
    return this.apiSvc.get(API_END_POINT.getDomainInfo(customerId), this.header);
  }

  internalLogin(data): Promise<ApiResponse> {
    // return this.apiSvc.postProvider('v2/login', data);
    return this.apiSvc.postProvider(API_END_POINT.internalLogin, data);
  }

  identityProviderLogin(data): Promise<ApiResponse> {
    // return this.apiSvc.postProvider('/auth/login', data, true);
    return this.apiSvc.postProvider(API_END_POINT.identityProviderLogin, data, true);
  }

  sendOTP(data): Promise<ApiResponse> {
    // return this.apiSvc.postProvider('authOption', data);
    return this.apiSvc.postProvider(API_END_POINT.sendOTP, data);
  }

  verifyOTP(userId, data): Promise<ApiResponse> {
    // return this.apiSvc.putProvider('validateOtp/' + userId, data);
    return this.apiSvc.putProvider(API_END_POINT.verifyOTP(userId) + userId, data);
  }
}
